import { render, staticRenderFns } from "./edit-button.vue?vue&type=template&id=588fae9f&scoped=true"
import script from "./edit-button.vue?vue&type=script&lang=js"
export * from "./edit-button.vue?vue&type=script&lang=js"
import style0 from "./edit-button.vue?vue&type=style&index=0&id=588fae9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fae9f",
  null
  
)

export default component.exports